<template>
  <div class='encode-tree-container'>
    <BaseTree :selectedNode.sync="curNode"
              :data="encodeTreeData">
      <template v-slot:ruleIcon>
        <i class="fa fa-bank"></i>
      </template>
      <template v-slot:flowIcon>
        <i class="fa fa-bar-chart"></i>
      </template>
      <template v-slot:menu="scope">

        <div v-show="scope.menuVisible && scope.data.parentName!==''">
          <el-menu id="rightClickMenu"
                   class="el-menu-vertical"
                   @select="(key)=>{handleRightSelect(key,scope)}"
                   active-text-color="#fff"
                   text-color="#fff">

            <el-menu-item index="1"
                          v-if="scope.data.level===2"
                          @click="createRule(scope)"
                          class="menuItem">
              <i class="el-icon-plus" />
              <span slot="title">新增规则</span>
            </el-menu-item>
            <el-menu-item index="1"
                          v-if="scope.data.level===3"
                          @click="createRule(scope)"
                          class="menuItem">
              <i class="el-icon-plus" />
              <span slot="title">新增流水</span>
            </el-menu-item>
            <el-menu-item index="2"
                          v-if="scope.data.resolve_type"
                          @click="updateRule(scope.data)"
                          class="menuItem">
              <i class="el-icon-circle-plus-outline" />
              <span slot="title">修改</span>
            </el-menu-item>
            <el-menu-item index="3"
                          v-if="!scope.data.system_name"
                          @click="deleteRule(scope)"
                          class="menuItem">
              <i class="el-icon-menu" />
              <span slot="title">删除</span>
            </el-menu-item>

          </el-menu>
        </div>
      </template>
    </BaseTree>
    <EditRuleDialog :dialogVisible.sync="editRuleDialogVisible"
                    @callback="editCallback"
                    :dialogForm="editRuleDialogForm"
                    :dialogStatus="editRuleDialogStatus"
                    :dialogType="editRuleDialogType"></EditRuleDialog>
  </div>
</template>
<script>
import BaseTree from '@/components/BaseTree/BaseTree'
import EditRuleDialog from './components/EditRuleDialog'
import { EncodeRuleApi } from '@/services/EncodeRule'
export default {
  data () {
    return {
      // 获取编码树请求参数
      requestParam: {

      },
      encodeTreeData: [],
      // 编辑规则分类和流水段分类弹框是否可见
      editRuleDialogVisible: false,
      // 编辑规则分类和流水段分类弹框数据对象
      editRuleDialogForm: {},
      // 编辑规则分类和流水段分类弹框状态
      editRuleDialogStatus: 'create',
      // 编辑规则或流水段
      editRuleDialogType: 'rule',
      // 当前选中节点
      curNode: {

      }
    }
  },
  components: {
    BaseTree,
    EditRuleDialog
  },
  props: {
    encodeTree: {
      type: Array,
      default: () => {
        return []
      }
    },
    param: {
      type: Object
    },
    selectedNode: {
      type: Object
    }
  },
  watch: {
    // 编码树数据
    encodeTree: {
      handler (newval) {
        if (newval) {
          this.encodeTreeData = this.handleTreeData(JSON.parse(JSON.stringify(newval)), '')
        }
      },
      deep: true
    },
    // 请求编码树接口参数
    param: {
      handler (newval) {
        if (newval) {
          this.requestParam = JSON.parse(JSON.stringify(newval))
        }
      },
      deep: true
    },
    // 当前选中节点
    curNode: {
      handler (newval) {
        this.$emit('update:selectedNode', newval)
      },
      deep: true
    }
  },
  methods: {
    // 处理右键点击事件
    handleRightSelect (key, scope) {

    },
    // 处理编码树数据
    handleTreeData (data, name) {
      if (Object.prototype.toString.call(data) === '[object Array]') {
        data.map(item => {
          item.parentName = name
          if (item.children) {
            this.handleTreeData(item.children, item.name)
          }
          if (!item.name) {
            item.name = item.system_name
          }
          if (item.rule_code_resolve_id) {
            item.id = item.rule_code_resolve_id
          } else if (!item.rule_code_resolve_id && !item.id) {
            item.id = item.system_no + item.company_id
          }
        })
        return data
      }
    },
    // 获取编码树数据
    getEncodeTreeData () {
      let a = 1
      EncodeRuleApi.getEncodeTree({
        params: this.requestParam
      }).then(res => {
        if (res.code === 0) {
          let treeData = [
            {
              id: '0',
              name: '编码规则',
              children: res.data
            }
          ]
          this.encodeTreeData = this.handleTreeData(treeData)
        }
      }, err => {
        console.log(err)
      })
    },
    // 编辑规则或流水段的成功回调
    editCallback (data) {
      this.getEncodeTreeData()
    },
    // 新增规则
    createRule (scope) {
      console.log(scope, 'create rule')
      let data = scope.data
      // 当前节点为系统时，只能添加规则
      // 当前节点为规则时，只能添加流水段
      if (data.system_name) {
        this.editRuleDialogForm = {
          system_no: data.system_no,
          company_id: data.company_id,
          resolve_type: 1
        }
        this.editRuleDialogStatus = 'create'
        this.editRuleDialogType = 'rule'
        this.editRuleDialogVisible = true
      } else {
        this.editRuleDialogForm = {
          system_no: data.system_no,
          company_id: data.company_id,
          parentName: data.name,
          resolve_no: data.resolve_no,
          resolve_type: 2
        }
        this.editRuleDialogStatus = 'create'
        this.editRuleDialogType = 'flow'
        this.editRuleDialogVisible = true
      }
    },
    // 修改规则
    updateRule (data) {
      this.editRuleDialogForm = data
      this.editRuleDialogStatus = 'updata'
      this.editRuleDialogType = data.resolve_type === '1' ? 'rule' : 'flow'
      this.editRuleDialogVisible = true
    },
    // 删除规则
    deleteRule (scope) {
      console.log(this.requestParam, scope)
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteRuleApi(scope.data.rule_code_resolve_id)
      }).catch(() => {

      })
    },
    // 调用删除规则api
    deleteRuleApi (id) {
      EncodeRuleApi.deleteEncodeTree({
        data: {
          rule_code_resolve_id: id
        }
      }).then(res => {
        if (res.code === 0) {
          this.$message.success('删除规则成功')
          this.getEncodeTreeData()
        }
      })
    }
  },
  created () {
  },
  mounted () {
  }
}
</script>
<style scoped lang='scss'>
.encode-tree-container {
  width: 320px;
  height:calc(100% - 70px);
}
/*************************标签鼠标右击页面样式******************************/
.el-menu-vertical {
  border: 3px solid rgb(84, 92, 100);
  border-radius: 10px;
  z-index: 100;
  width: 160px;
  .menuItem {
    height: 40px;
    line-height: 40px;
    /* background-color: #545c64; */
    background-color: #545c64;
    font-size: 16px;
    &:hover {
      background-color: #409eff;
    }
    i {
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/EncodeTree/EncodeTree.vue